import React from 'react'
import { Form, Input } from 'antd';
const { TextArea } = Input;
const TextFieldBox = ({label,name, value, rules, ...rest}) => {
    return ( 
       
        <Form.Item
            label={label}
            name={name}
            rules={rules}
            
            >
            <TextArea rows={4} {...rest} />
        </Form.Item>
     );
}
 
export default TextFieldBox;